import dayjs from "dayjs";
import "dayjs/locale/ko";

dayjs.locale("ko");

// 예약 취소 마감 기한 표시용 포맷.
// 분이 0이면 "분"을 생략한다.
// 예) 2026-07-01 00:00 -> 2026-07-01(수) 오전 0시
//     2026-07-01 14:30 -> 2026-07-01(수) 오후 2시 30분
export function formatBookCancelTerm(dtm) {
  const target = dayjs(dtm);
  const format =
    target.minute() === 0 ? "YYYY-MM-DD(dd) A h시" : "YYYY-MM-DD(dd) A h시 m분";
  return target.format(format);
}
